const generateUniqueTemplateKey = (pathname) => {
  const pathParams = pathname.split('/');
  pathParams.shift();
  const subType = pathParams?.[2] ? `_${pathParams?.[2]}` : '';
  return pathParams?.[0] + '_' + pathParams?.[1] + subType;
};

export {generateUniqueTemplateKey};
